import { schema } from 'normalizr';

export const skill = new schema.Entity('skill', {}, {
    processStrategy: ({id, ...value}) => ({
        ...value,
        id: Number(id)
    })
});
export const skillList = [ skill ];
